var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnUpdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    width: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.027 4.797a.285.285 0 01.017-.285L6.1.122a.285.285 0 01.468 0l3.056 4.39a.279.279 0 01-.237.436H3.281a.285.285 0 01-.254-.151zm6.36 2.255H3.281a.279.279 0 00-.237.436l3.056 4.39a.285.285 0 00.468 0l3.056-4.39a.279.279 0 00-.237-.436z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12v12H0z",
    fill: "none"
  })));
}
export default __webpack_public_path__ + "media/icons/icn_updown-47cf30de.svg";
export { SvgIcnUpdown as ReactComponent };